const mapLocalityTransformer = locality => ({
    id: locality.id,
    idIne: locality.id_ine,
    name: {
        eu: locality.municipio_eu,
        es: locality.municipio,
    },
})

export default mapLocalityTransformer